import { render, staticRenderFns } from "./WidgetHighlight.vue?vue&type=template&id=55e8b7ef&"
import script from "./WidgetHighlight.vue?vue&type=script&lang=js&"
export * from "./WidgetHighlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetHighlight.vue"
export default component.exports